// extracted by mini-css-extract-plugin
export default {"box":"SimulatorHeader_box__5Uoi5","title":"SimulatorHeader_title__qqUGa"};